(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const entities = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&apos;': "'", '&#x27;': "'" };
    const data = JSON.parse(root.querySelector('[data-hw-data]').textContent, (_key, value) => typeof value === 'string' ? value.replace(/&(?:amp|lt|gt|quot|apos|#39|#x27);/g, entity => entities[entity]) : value);
    const ui = data.ui;
    const products = data.products;
    const find = id => products.find(p => p.id === id);
    const q = selector => root.querySelector(selector);
    const qa = selector => [...root.querySelectorAll(selector)];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    function icon(kind) {
      const paths = {
        arrow: 'M5 12h14m-6-6 6 6-6 6',
        bookmark: 'M7 4h10a1 1 0 0 1 1 1v15l-6-4-6 4V5a1 1 0 0 1 1-1Z',
        check: 'm5 12 4 4L19 6',
        plus: 'M12 5v14M5 12h14',
        heart: 'M20.5 5.5a5 5 0 0 0-7 0L12 7l-1.5-1.5a5 5 0 0 0-7 7L12 21l8.5-8.5a5 5 0 0 0 0-7Z',
        replay: 'M20 5v6h-6M20 11a8 8 0 1 0-2.3 6.7'
      };
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.classList.add('hw-action-icon');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', paths[kind] || paths.arrow);
      svg.append(path);
      return svg;
    }
    function setButtonIcon(button, kind) {
      const symbol = button.querySelector('.hw-button-symbol');
      if (!symbol || symbol.dataset.icon === kind) return;
      symbol.dataset.icon = kind;
      symbol.replaceChildren(icon(kind));
    }
    function dressButton(button) {
      if (button.querySelector('.hw-button-label')) return;
      const picture = button.querySelector('img');
      const label = document.createElement('span');
      label.className = 'hw-button-label';
      label.textContent = button.textContent.replace(/↗/g, '').trim();
      const symbol = document.createElement('span');
      symbol.className = 'hw-button-symbol';
      symbol.setAttribute('aria-hidden', 'true');
      button.replaceChildren();
      if (picture) button.append(picture);
      button.append(label, symbol);
      setButtonIcon(button, button.matches('[data-hw-detail-save]') ? 'bookmark' : button.hasAttribute('data-hw-replay') ? 'replay' : 'arrow');
    }
    function setButtonLabel(button, text, kind) {
      dressButton(button);
      button.querySelector('.hw-button-label').textContent = kind === 'check' ? text.replace(/\s*✓\s*$/, '') : text;
      if (kind) {
        setButtonIcon(button, kind);
        button.dataset.hwSaved = String(kind === 'check');
        if (button.hasAttribute('data-hw-detail-save')) button.setAttribute('aria-pressed', String(kind === 'check'));
      }
    }
    qa('.hw-button,.hw-card > .hw-text-button,.hw-theatre-enquiry,.hw-editorial > .hw-text-button').forEach(dressButton);
    const storageKey = 'efestore-halloween-selection-v5';
    let selected = [];
    try { selected = JSON.parse(localStorage.getItem(storageKey) || '[]').filter(id => find(id)); } catch (_) {}
    selected = [...new Set(selected)];
    let filter = 'all';
    let query = '';
    let current = null;
    let galleryIndex = 0;
    let transitionToken = 0;
    let productTransition;
    let toastTimer;
    const openerByDialog = new WeakMap();
    function toast(message) {
      const node = q('[data-hw-toast]');
      node.textContent = message;
      node.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { node.hidden = true; }, 2300);
    }
    function open(dialog, opener) {
      if (!dialog || dialog.open) return;
      openerByDialog.set(dialog, opener || document.activeElement);
      dialog.showModal();
    }
    function close(dialog) {
      if (!dialog || !dialog.open) return;
      dialog.close();
    }
    qa('dialog').forEach(dialog => {
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(dialog);
      });
      dialog.addEventListener('close', () => {
        const opener = openerByDialog.get(dialog);
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      });
    });
    function flight(count = 12) { window.EfeHalloweenMotion?.flight(count); }
    function runTransition(action) {
      const token = ++transitionToken;
      flight(11);
      const status = q('[data-hw-transition]');
      status.hidden = false;
      setTimeout(() => {
        if (token !== transitionToken || !root.isConnected) return;
        status.hidden = true;
        action();
      }, reduced.matches || root.dataset.motion === 'false' ? 0 : 170);
    }
    function normalize(s) { return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(); }
    function renderFilters() {
      let count = 0;
      qa('[data-hw-card]').forEach(card => {
        const product = find(card.dataset.hwCard);
        const categoryMatch = filter === 'all' || product.category === filter;
        const queryMatch = normalize(product.name + ' ' + product.sub + ' ' + product.description).includes(normalize(query));
        card.hidden = !(categoryMatch && queryMatch);
        if (!card.hidden) count++;
      });
      qa('[data-hw-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hwFilter === filter)));
      q('[data-hw-editorial]').hidden = filter !== 'all' || !!query;
      q('[data-hw-empty]').hidden = count !== 0;
      q('[data-hw-results]').textContent = count === 1 ? ui.resultOne : ui.results.replace('%count%', String(count));
    }
    function chooseFilter(value, scroll) {
      filter = value;
      query = '';
      q('[data-hw-search]').value = '';
      renderFilters();
      if (scroll) q('#hw-collection').scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
    }
    function save() {
      try { localStorage.setItem(storageKey, JSON.stringify(selected)); } catch (_) {}
      qa('[data-hw-save]').forEach(button => {
        const isSelected = selected.includes(button.dataset.hwSave);
        button.setAttribute('aria-pressed', String(isSelected));
        const kind = isSelected ? 'check' : button.classList.contains('hw-save') ? 'heart' : 'plus';
        if (button.dataset.icon !== kind) {
          button.dataset.icon = kind;
          button.replaceChildren(icon(kind));
        }
        button.setAttribute('aria-label', (isSelected ? ui.remove : ui.save) + ': ' + find(button.dataset.hwSave).name);
      });
      q('[data-hw-selection-count]').textContent = String(selected.length);
      q('[data-hw-selection-count]').hidden = !selected.length;
      if (current) setButtonLabel(q('[data-hw-detail-save]'), selected.includes(current.id) ? ui.saved : ui.saveSelection, selected.includes(current.id) ? 'check' : 'bookmark');
      renderSelection();
    }
    function toggleSelection(id) {
      selected = selected.includes(id) ? selected.filter(item => item !== id) : [...selected, id];
      save();
      toast(selected.includes(id) ? ui.added : ui.removed);
    }
    function renderSelection() {
      const items = q('[data-hw-selection-items]');
      items.replaceChildren();
      if (!selected.length) {
        const empty = document.createElement('p');
        empty.className = 'hw-empty';
        empty.style.marginTop = '24px';
        empty.textContent = ui.selectionEmpty;
        items.append(empty);
      }
      selected.forEach(id => {
        const product = find(id);
        const row = document.createElement('article');
        row.className = 'hw-selection-row';
        const image = document.createElement('img');
        image.src = product.images[0]; image.alt = product.name; image.width = 74; image.height = 85;
        image.loading = 'lazy'; image.decoding = 'async';
        const info = document.createElement('div');
        const title = document.createElement('h3'); title.textContent = product.name;
        const subtitle = document.createElement('p'); subtitle.textContent = product.sub;
        const actions = document.createElement('div'); actions.className = 'hw-selection-actions';
        if (product.available && product.url) {
          const price = document.createElement('p'); price.className = 'hw-selection-price'; price.textContent = product.price;
          const priceNote = document.createElement('p'); priceNote.className = 'hw-selection-price-note'; priceNote.textContent = ui.selectionPriceNote;
          const purchase = document.createElement('a'); purchase.className = 'hw-selection-purchase'; purchase.href = product.url;
          purchase.textContent = product.purchaseLabel; purchase.setAttribute('aria-label', product.purchaseLabel + ': ' + product.name);
          info.append(title, subtitle, price, priceNote); actions.append(purchase);
        } else {
          const status = document.createElement('p'); status.className = 'hw-selection-price-note'; status.textContent = product.status;
          info.append(title, subtitle, status);
        }
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = ui.remove; remove.dataset.hwRemove = id;
        remove.setAttribute('aria-label', ui.remove + ': ' + product.name);
        actions.append(remove); info.append(actions); row.append(image, info); items.append(row);
      });
      q('[data-hw-enquire-selection]').hidden = !selected.length;
      const body = ui.enquiryIntro + '\n\n' + selected.map(id => find(id).name).join('\n') + '\n\n' + ui.enquiryEnd;
      q('[data-hw-enquire-selection]').href = 'mailto:' + data.email + '?subject=' + encodeURIComponent(ui.enquirySubject) + '&body=' + encodeURIComponent(body);
    }
    function piece(product) {
      const row = document.createElement('article');
      row.className = 'hw-piece';
      const details = document.createElement('button');
      details.type = 'button';
      details.className = 'hw-piece-details';
      details.dataset.hwProduct = product.id;
      details.setAttribute('aria-label', ui.details + ': ' + product.name);
      const image = document.createElement('img');
      image.src = product.images[0]; image.alt = ''; image.width = 68; image.height = 68; image.loading = 'lazy';
      const info = document.createElement('span');
      const name = document.createElement('strong'); name.textContent = product.name;
      const sub = document.createElement('small'); sub.textContent = product.sub;
      const arrow = document.createElement('span'); arrow.className = 'hw-piece-arrow'; arrow.append(icon('arrow')); arrow.setAttribute('aria-hidden', 'true');
      info.append(name, sub); details.append(image, info, arrow);
      const saveButton = document.createElement('button');
      saveButton.type = 'button'; saveButton.className = 'hw-piece-save'; saveButton.dataset.hwSave = product.id;
      row.append(details, saveButton);
      return row;
    }
    function related(product) {
      const pairings = { candles: ['bats', 'web'], bats: ['candles', 'web'], mask: ['bats', 'web'], web: ['bats', 'candles'], frankie: ['pumpkin', 'bats'], pumpkin: ['frankie', 'web'], phone: ['candles', 'bats'] };
      const list = q('[data-hw-related]');
      list.replaceChildren();
      (pairings[product.id] || []).map(find).filter(Boolean).forEach(item => list.append(piece(item)));
      save();
    }
    function setGallery(index) {
      galleryIndex = index;
      const image = q('[data-hw-detail-image]');
      image.src = current.images[index]; image.alt = current.name;
      qa('[data-hw-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.hwGalleryIndex) === index)));
    }
    function productMorph(action) {
      if (!document.startViewTransition || reduced.matches || root.dataset.motion === 'false') { action(); return; }
      productTransition?.skipTransition();
      const image = q('[data-hw-detail-image]');
      const info = q('.hw-detail-info');
      image.style.viewTransitionName = 'efe-product-photo';
      info.style.viewTransitionName = 'efe-product-info';
      try {
        const transition = document.startViewTransition(action);
        productTransition = transition;
        transition.finished.catch(() => {}).finally(() => {
          if (productTransition !== transition) return;
          image.style.viewTransitionName = '';
          info.style.viewTransitionName = '';
          productTransition = null;
        });
      } catch (_) { image.style.viewTransitionName = ''; info.style.viewTransitionName = ''; action(); }
    }
    function productDetails(id, opener) {
      const product = find(id);
      if (!product) return;
      const render = () => {
        current = product;
        q('[data-hw-detail-title]').textContent = product.name;
        q('[data-hw-detail-category]').textContent = product.categoryLabel;
        q('[data-hw-detail-description]').textContent = product.description;
        qa('[data-catalog-status]').forEach(node => { node.textContent = product.status; });
        const price = q('[data-catalog-price]');
        price.textContent = product.price || '';
        price.hidden = !product.available;
        const purchase = q('[data-catalog-purchase]');
        purchase.hidden = !product.available || !product.url;
        purchase.href = product.url || '#';
        setButtonLabel(purchase, product.purchaseLabel || ui.details, 'arrow');
        q('[data-catalog-note]').textContent = product.note;
        const specs = q('[data-hw-detail-specs]'); specs.replaceChildren();
        product.specs.forEach(text => { const item = document.createElement('li'); item.textContent = text; specs.append(item); });
        const gallery = q('[data-hw-gallery]'); gallery.replaceChildren();
        product.images.forEach((source, index) => {
          const button = document.createElement('button'); button.type = 'button'; button.dataset.hwGalleryIndex = String(index); button.setAttribute('aria-label', ui.photo + ' ' + (index + 1));
          const thumbnail = document.createElement('img'); thumbnail.src = source; thumbnail.alt = ''; thumbnail.width = 64; thumbnail.height = 64; thumbnail.loading = 'lazy'; button.append(thumbnail); gallery.append(button);
        });
        gallery.hidden = product.images.length < 2;
        setGallery(0);
        setButtonLabel(q('[data-hw-detail-save]'), selected.includes(id) ? ui.saved : ui.saveSelection, selected.includes(id) ? 'check' : 'bookmark');
        q('[data-hw-product-enquiry]').href = 'mailto:' + data.email + '?subject=' + encodeURIComponent(ui.enquirySubject + ' — ' + product.name) + '&body=' + encodeURIComponent(ui.enquiryIntro + '\n\n' + product.name + '\n\n' + ui.enquiryEnd);
        related(product);
        const dialog = q('[data-hw-product-dialog]');
        if (dialog.open) {
          dialog.scrollTop = 0;
          q('[data-hw-detail-title]').focus({ preventScroll: true });
        } else open(dialog, opener);
        root.dispatchEvent(new CustomEvent('efe:product-opened', { bubbles: true, detail: { id: product.id } }));
      };
      if (q('[data-hw-product-dialog]').open) productMorph(render); else runTransition(render);
    }
    root.addEventListener('click', event => {
      const button = event.target.closest('button,a');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-hw-close')) close(button.closest('dialog'));
      else if (button.hasAttribute('data-hw-replay')) { flight(); toast(reduced.matches ? ui.reducedMotion : ui.replayStatus); }
      else if (button.dataset.hwFilter) chooseFilter(button.dataset.hwFilter, false);
      else if (button.dataset.hwCategory) { close(q('[data-hw-menu]')); chooseFilter(button.dataset.hwCategory, true); }
      else if (button.dataset.hwProduct) productDetails(button.dataset.hwProduct, button);
      else if (button.dataset.hwSave) toggleSelection(button.dataset.hwSave);
      else if (button.dataset.hwRemove) toggleSelection(button.dataset.hwRemove);
      else if (button.hasAttribute('data-hw-detail-save') && current) toggleSelection(current.id);
      else if (button.hasAttribute('data-hw-open-selection')) { close(q('[data-hw-menu]')); open(q('[data-hw-selection]'), button); }
      else if (button.hasAttribute('data-hw-open-menu')) open(q('[data-hw-menu]'), button);
      else if (button.hasAttribute('data-hw-search-open')) {
        close(q('[data-hw-menu]'));
        const box = q('[data-hw-search-box]'); box.hidden = false; chooseFilter('all', true); q('[data-hw-search]').focus({ preventScroll: true });
      }
      else if (button.hasAttribute('data-hw-search-close')) { q('[data-hw-search-box]').hidden = true; query = ''; q('[data-hw-search]').value = ''; renderFilters(); }
      else if (button.hasAttribute('data-hw-reset')) chooseFilter('all', false);
      else if (button.hasAttribute('data-hw-gallery-index')) setGallery(Number(button.dataset.hwGalleryIndex));
      else if (button.hasAttribute('data-hw-zoom') && current) {
        q('[data-hw-zoom-image]').src = current.images[galleryIndex]; q('[data-hw-zoom-image]').alt = current.name; open(q('[data-hw-zoom-dialog]'), button);
      }
      else if (button.hasAttribute('data-hw-menu-link')) close(q('[data-hw-menu]'));
    });
    q('[data-hw-search]').addEventListener('input', event => { query = event.target.value; renderFilters(); });
    qa('[data-hw-language]').forEach(select => select.addEventListener('change', () => select.form.submit()));
    renderFilters();
    save();
    if ('IntersectionObserver' in window) {
      const openingSection = q('.hw-kids') || q('.hw-hero');
      let heroVisible = true;
      let contactVisible = false;
      const update = () => { q('[data-hw-mobile-action]').hidden = heroVisible || contactVisible; };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === openingSection) heroVisible = entry.isIntersecting;
          else contactVisible = entry.isIntersecting;
        });
        update();
      }, { threshold: .08 });
      observer.observe(openingSection);
      observer.observe(q('#hw-contact'));
    }
    if ('IntersectionObserver' in window && !reduced.matches) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('hw-in-view'); observer.unobserve(entry.target); } });
      }, { threshold: .07, rootMargin: '0px 0px -20px 0px' });
      qa('.hw-heading,.hw-category,.hw-card,.hw-editorial,.hw-kid-look,.hw-everyday,.hw-story,.hw-note,.hw-contact').forEach((node, index) => {
        if (node.matches('.hw-kid-look') || node.closest('.hw-kids')) return;
        node.classList.add('hw-reveal');
        node.style.transitionDelay = Math.min(index % 3 * 40, 80) + 'ms';
        observer.observe(node);
      });
      reduced.addEventListener('change', () => { if (reduced.matches) qa('.hw-reveal').forEach(node => node.classList.add('hw-in-view')); });
    }
    if (matchMedia('(hover:hover) and (pointer:fine)').matches && !reduced.matches) {
      qa('.hw-button--outline,.hw-category,.hw-card').forEach(node => {
        let frame;
        node.addEventListener('pointermove', event => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const box = node.getBoundingClientRect();
            node.style.setProperty('--mx', (event.clientX - box.left) / box.width * 100 + '%');
            node.style.setProperty('--my', (event.clientY - box.top) / box.height * 100 + '%');
          });
        });
      });
    }
    const progress = document.createElement('span');
    progress.className = 'hw-reading-progress';
    progress.setAttribute('aria-hidden', 'true');
    q('.hw-nav-shell').append(progress);
    let scrollFrame;
    const updateProgress = () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const length = document.documentElement.scrollHeight - innerHeight;
        progress.style.setProperty('--progress', length > 0 ? Math.min(1, scrollY / length) : 0);
      });
    };
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
    window.addEventListener('storage', event => {
      if (event.key !== storageKey) return;
      try { selected = [...new Set(JSON.parse(event.newValue || '[]').filter(find))]; save(); } catch (_) {}
    });
  }
  function mount(scope = document) { scope.querySelectorAll('[data-hw-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount()); else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();



